<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="(insurance.id ? 'Edit' : 'Add') + ' Insurance Policy  [' + jobsite.JobsiteName + '] :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jobsites`">
                            <i class="fa fa-building"></i> Jobsites
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jobsites/view/${jobsiteId}`">
                            <span v-if="jobsite.JobsiteNumber">{{ jobsite.JobsiteNumber }} -&nbsp;</span>{{ jobsite.JobsiteName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ insurance.id ? 'Edit' : 'Add' }} Insurance Policy
                    </li>
                </ol>
            </h4>
            <div class="row">
                <div class="col-xl-6 col-lg-8 col-md-7">
                    <div class="card">
                        <div class="card-header">
                            {{ insurance.id ? 'Edit' : 'Add' }} Insurance Policy
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.coverage_type, 'text-danger': errors.coverage_type}">
                                    Coverage Type: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-input v-model="insurance.coverage_type" :class="{'is-invalid': errors.coverage_type}" placeholder="Enter Coverage Type" />

                                    <ul v-if="errors.coverage_type" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.coverage_type">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.policy_nbr, 'text-danger': errors.policy_nbr}">
                                    Policy#: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-lg-6">
                                    <b-form-input v-model="insurance.policy_nbr" :class="{'is-invalid': errors.policy_nbr}" placeholder="Enter Policy#" />

                                    <ul v-if="errors.policy_nbr" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.policy_nbr">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.coverage_amount, 'text-danger': errors.coverage_amount}">
                                    Amount: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-lg-6">
                                    <div class="input-group">
                                       <div class="input-group-prepend">
                                           <div class="input-group-text bg-light">$</div>
                                       </div>
                                       <input type="number" min="0" v-model="insurance.coverage_amount" :class="{'is-invalid': errors.coverage_amount, 'form-control': true}" placeholder="Enter Coverage Amount" />
                                    </div>

                                    <ul v-if="errors.coverage_amount" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.coverage_amount">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.start_date, 'text-danger': errors.start_date}">
                                    Start Date: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-lg-6">
                                    <input type="date" v-model="insurance.start_date" :class="{'is-invalid': errors.start_date}" class="form-control" placeholder="Enter Start Date" />

                                    <ul v-if="errors.start_date" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.start_date">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.expire_date, 'text-danger': errors.expire_date}">
                                    Expire Date: <i class="fa fa-asterisk small text-danger"></i>
                                </div>
                                <div class="col-lg-6">
                                    <input type="date" v-model="insurance.expire_date" :class="{'is-invalid': errors.expire_date}" class="form-control" placeholder="Enter Expire Date" />

                                    <ul v-if="errors.expire_date" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.expire_date">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-3 text-lg-right pt-1" :class="{'text-muted': !errors.policy, 'text-danger': errors.policy}">
                                    Copy of Policy:
                                </div>
                                <div class="col-lg-6">
                                    <b-form-file v-model="policy" :class="{'is-invalid': errors.policy}" placeholder="Attach a Copy of the Insurance Policy" />

                                    <ul v-if="errors.policy" class="list-unstyled text-danger mt-1 mb-0">
                                        <li v-for="error in errors.policy">
                                            {{ error }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-sm btn-success" v-on:click="saveInsurance()" :disabled="saving">
                                <template v-if="saving">Saving</template>
                                <template v-else>Save</template>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                policy: null,
                jobsiteId: this.$route.params.jobsiteId,
                insuranceId: this.$route.params.insuranceId,
                jobsite: {},
                insurance: {},
                errors: {},
            }
        },

        methods: {

            getInsurance() {
                //Get the data
                this.$http
                    .get('jobsites/insurance/' + this.jobsiteId + '/edit' + (this.insuranceId ? '/' + this.insuranceId : '') )
                    .then(response => {
                        //Set all the data
                        this.jobsite = response.data.jobsite;
                        this.insurance = response.data.insurance;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveInsurance() {
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .postWithSingleFile('jobsites/insurance/' + this.jobsiteId + '/edit', this.insurance, this.policy, 'policy')
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Insurance Policy Saved');

                    //Return to main list?
                    this.$router.push('/jobsites/view/'+this.jobsiteId);
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },
        },

        mounted() {
            //Get the jobsites
            this.getInsurance();
        }
    }
</script>
